import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/app/compare/components/CompareContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Header.tsx");
